import * as yup from 'yup';

export const accountManagerFormSchema = yup.object().shape({
  message: yup.string().required('You must enter a message'),
});
